import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const savePacking = createAsyncThunk(
    "tatmeenPacking/save",
    async (payload, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/packing/save", payload);
            if (res.data.status === false) {
                throw new Error(res.data.message);
            }
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to save packing"
            );
        }
    }
);

export const fetchPackingList = createAsyncThunk(
    "tatmeenPacking/fetchList",
    async (_, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/packing/list", {});
            return res.data.data || [];
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch packing list"
            );
        }
    }
);

export const fetchPackingDetail = createAsyncThunk(
    "tatmeenPacking/fetchDetail",
    async (id, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/packing/detail", { id });
            if (res.data.status === false) {
                throw new Error(res.data.message);
            }
            return res.data.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to fetch packing detail"
            );
        }
    }
);

export const updatePackingItems = createAsyncThunk(
    "tatmeenPacking/updateItems",
    async (payload, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/packing/update", payload);
            if (res.data.status === false) {
                throw new Error(res.data.message);
            }
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to update packing"
            );
        }
    }
);

export const sendPackingEvent = createAsyncThunk(
    "tatmeenPacking/sendEvent",
    async (id, thunkAPI) => {
        try {
            const res = await postData("/tatmeen/packing/send", { id });
            if (res.data.status === false) {
                throw new Error(res.data.message);
            }
            return res.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error.response?.data?.message ||
                error.message ||
                "Failed to send packing event"
            );
        }
    }
);
